import React, { useState } from 'react';
import TechBadge from '../components/TechBadge';
import { Github, Linkedin, MessageCircle, Discord, Copy, Check } from 'lucide-react';
import { FaDiscord } from "react-icons/fa";

const Home = () => {
  const [showDiscordPopup, setShowDiscordPopup] = useState(false);
  const [copied, setCopied] = useState(false);
  const discordUsername = 'totowilwil';

  const handleCopyDiscord = () => {
    navigator.clipboard.writeText(discordUsername);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  const handleDiscordClick = (e) => {
    e.preventDefault();
    setShowDiscordPopup(true);
  };
  const technologies = [
    {
      name: 'React',
      logoUrl: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/react/react-original.svg',
      url: 'https://github.com/facebook/react'
    },
    {
      name: 'Next.js',
      logoUrl: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/nextjs/nextjs-original.svg',
      url: 'https://github.com/vercel/next.js'
    },
    {
      name: 'NestJS',
      logoUrl: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/nestjs/nestjs-original.svg',
      url: 'https://github.com/nestjs/nest'
    },
    {
      name: 'PostgreSQL',
      logoUrl: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/postgresql/postgresql-original.svg',
      url: 'https://github.com/postgres/postgres'
    },
    {
      name: 'TypeScript',
      logoUrl: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/typescript/typescript-original.svg',
      url: 'https://github.com/microsoft/TypeScript'
    },
    {
      name: 'TailwindCSS',
      logoUrl: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/tailwindcss/tailwindcss-original.svg',
      url: 'https://github.com/tailwindlabs/tailwindcss'
    },
  ];

  const clients = [
    {
      name: 'Jungle Bike',
      logoUrl: 'https://scontent-cdg4-2.cdninstagram.com/v/t51.2885-19/328549324_231611109205777_6090569670133112997_n.jpg?stp=dst-jpg_s150x150_tt6&efg=eyJ2ZW5jb2RlX3RhZyI6InByb2ZpbGVfcGljLmRqYW5nby4xMDgwLmMyIn0&_nc_ht=scontent-cdg4-2.cdninstagram.com&_nc_cat=101&_nc_oc=Q6cZ2QG_KxZU_xa8_PTHskQ7XUgoRm2SrV3NZwmYzC_1HpJqbGaxSaQtU-QUro8tHbt8hUADdmAMvv5Zqt-BAgTFpMQB&_nc_ohc=17M7_tga6XMQ7kNvwFSo-CG&_nc_gid=1Nq9UOhO3YoHKpbjUHMFxw&edm=AP4sbd4BAAAA&ccb=7-5&oh=00_AfiuyWqcowS7T59fLNVKIqE0U3UHEd9vna9InSonvHEKAg&oe=69244E15&_nc_sid=7a9f4b',
      url: 'https://junglebike.fr/'
    },
    {
      name: 'Partech Partners',
      logoUrl: 'https://logos-world.net/wp-content/uploads/2023/10/Partech-Symbol.png',
      url: 'https://partechpartners.com'
    },
    {
      name: 'Groupe Mobilier Solidaire',
      logoUrl: 'https://i0.wp.com/mobiliersolidaire.com/wp-content/uploads/2024/09/LOGO-GMSss-edited.png?fit=962%2C541&ssl=1',
      url: 'https://mobiliersolidaire.com/'
    },
    {
      name: '6ixtes',
      logoUrl: 'https://i0.wp.com/ateliersdefrance.com/wp-content/uploads/2020/10/6ixtes_Logo_blanc.jpg?fit=1456%2C840&ssl=1',
      url: 'https://www.6ixtes.com/'
    },
    {
      name: 'Link Up',
      logoUrl: 'https://link-up.fr/wp-content/uploads/2024/04/LINKUP-full-1-1.png',
      url: 'https://link-up.fr/'
    },
  ];

  const socialLinks = [
    { name: 'GitHub', icon: Github, url: 'https://github.com/twillsonepitech' },
    { name: 'LinkedIn', icon: Linkedin, url: 'https://www.linkedin.com/in/twillson7' },
    { name: 'Discord', icon: FaDiscord, url: 'https://discord.com/users/totowilwil' },
  ];

  return (
    <div className="space-y-10">
      {/* Hero Section */}
      <section>
        <h1 className="text-5xl font-bold mb-6 text-gray-900 dark:text-gray-100">
          Thomas Willson
        </h1>
        <p className="text-lg text-gray-600 dark:text-gray-400 mb-6 leading-relaxed">
          <strong>Bonjour</strong> ! Je suis Thomas Willson, <strong>développeur fullstack freelance depuis 3 ans</strong> et <strong>software engineer</strong>.
        </p>

        <div className="space-y-3 text-gray-700 dark:text-gray-300">
          <p>
            <span className="text-gray-500 dark:text-gray-400">Freelance à</span>{' '}
            <span className="font-medium">Paris, France</span>
          </p>

          <div className="flex flex-wrap items-center gap-2">
            <span className="text-gray-500 dark:text-gray-400">Travaille avec</span>
            {technologies.map((tech, index) => (
              <TechBadge key={index} name={tech.name} logoUrl={tech.logoUrl} url={tech.url} />
            ))}
          </div>

          <div className="flex flex-wrap items-center gap-2">
            <span className="text-gray-500 dark:text-gray-400">Clients</span>
            {clients.map((client, index) => (
              <TechBadge key={index} name={client.name} logoUrl={client.logoUrl} url={client.url} />
            ))}
          </div>
        </div>
      </section>

      {/* About Section */}
      <section className="space-y-4 text-gray-700 dark:text-gray-300 leading-relaxed">
        <p>
          Développeur full-stack freelance basé à Paris, j'interviens sur des projets web complets — du design d'interface à l'architecture backend. Mon approche est centrée sur la qualité du code, la scalabilité et la livraison rapide de produits concrets.
        </p>

        <p>
          J'ai travaillé avec des startups, PME et fonds d'investissement comme{' '}
          <a href="https://partechpartners.com" className="text-gray-900 dark:text-gray-100 hover:underline">
            Partech Partners
          </a>
          , où j'ai contribué à des outils internes et à la modernisation de leur infrastructure web.
        </p>

        <p>
          Je participe à des{' '}
          <a href="/hackathons" className="text-gray-900 dark:text-gray-100 hover:underline">
            hackathons
          </a>{' '}
          et partage mes{' '}
          <a href="/experiences" className="text-gray-900 dark:text-gray-100 hover:underline">
            expériences professionnelles
          </a>{' '}
          sur le développement web, JavaScript moderne et la construction d'applications scalables. Vous pouvez consulter ma{' '}
          <a href="/projects" className="text-gray-900 dark:text-gray-100 hover:underline">
            liste complète de projets ici
          </a>
          .
        </p>

        <p>
          Je conçois des produits web complets, performants et maintenables. Mon approche : du code clair, des outils modernes, et une forte autonomie dans la livraison — que ce soit pour un MVP ou un produit déjà en production.
        </p>

        <p>
          N'hésitez pas à me{' '}
          <a href="/contact" className="text-gray-900 dark:text-gray-100 hover:underline">
            contacter
          </a>{' '}
          si vous souhaitez collaborer ou discuter d'un projet !
        </p>
      </section>

      <div className="border-t border-gray-200 dark:border-gray-800 my-10"></div>

      {/* Social Links */}
      <section>
        <h3 className="text-sm text-gray-500 dark:text-gray-400 mb-4">Me retrouver sur</h3>
        <div className="flex flex-wrap gap-4">
          {socialLinks.map((social, index) => {
            const Icon = social.icon;
            const isDiscord = social.name === 'Discord';
            return (
              <a
                key={index}
                href={isDiscord ? '#' : social.url}
                target={isDiscord ? undefined : "_blank"}
                rel={isDiscord ? undefined : "noopener noreferrer"}
                onClick={isDiscord ? handleDiscordClick : undefined}
                className="inline-flex items-center gap-2 text-gray-700 dark:text-gray-300 hover:text-gray-900 dark:hover:text-gray-100 transition-colors cursor-pointer"
              >
                <Icon size={16} />
                <span className="text-sm">{social.name}</span>
              </a>
            );
          })}
        </div>

        <p className="mt-4 text-gray-600 dark:text-gray-400 text-sm">
          Ou par email à{' '}
          <a href="mailto:twillson.pro@gmail.com" className="text-gray-900 dark:text-gray-100 hover:underline">
            twillson.pro@gmail.com
          </a>
        </p>
      </section>

      {/* Footer */}
      <footer className="pt-10 pb-6 text-center text-sm text-gray-500 dark:text-gray-500">
        <p className="mb-2">
          Design inspiré de{' '}
          <a
            href="https://antfu.me"
            target="_blank"
            rel="noopener noreferrer"
            className="hover:text-gray-700 dark:hover:text-gray-400"
          >
            antfu.me
          </a>
        </p>
        <p>
          <a
            href="https://creativecommons.org/licenses/by-nc-sa/4.0/"
            target="_blank"
            rel="noopener noreferrer"
            className="hover:text-gray-700 dark:hover:text-gray-400"
            title="Licence Creative Commons - Attribution, usage non-commercial, partage dans les mêmes conditions"
          >
            CC BY-NC-SA 4.0
          </a>{' '}
          2021-PRÉSENT © Thomas Willson
        </p>
      </footer>

      {/* Discord Popup */}
      {showDiscordPopup && (
        <div
          className="fixed inset-0 bg-black/30 backdrop-blur-sm flex items-center justify-center z-50 p-4"
          onClick={() => setShowDiscordPopup(false)}
        >
          <div
            className="bg-white dark:bg-[#0f0f0f] border border-gray-200 dark:border-gray-800 rounded-lg p-8 max-w-md w-full mx-4 transform transition-all"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="mb-6">
              <h3 className="text-xl font-light text-gray-900 dark:text-gray-100 mb-2">
                Discord
              </h3>
              <p className="text-sm text-gray-500 dark:text-gray-400">
                Ajoutez-moi en ami avec ce pseudo :
              </p>
            </div>

            <div className="flex items-center gap-3 mb-8">
              <div className="flex-1 border border-gray-200 dark:border-gray-800 px-4 py-3 rounded">
                <code className="text-gray-900 dark:text-gray-100 font-mono text-sm">
                  {discordUsername}
                </code>
              </div>
              <button
                onClick={handleCopyDiscord}
                className="px-4 py-3 text-gray-500 dark:text-gray-400 hover:text-gray-900 dark:hover:text-gray-100 transition-colors flex items-center gap-2 text-sm"
                title={copied ? "Copié !" : "Copier"}
              >
                {copied ? (
                  <Check size={18} />
                ) : (
                  <Copy size={18} />
                )}
              </button>
            </div>

            <button
              onClick={() => setShowDiscordPopup(false)}
              className="w-full text-center text-gray-500 dark:text-gray-400 hover:text-gray-900 dark:hover:text-gray-100 transition-colors text-sm"
            >
              Fermer
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default Home;
